import { render, staticRenderFns } from "./company-suspended.vue?vue&type=template&id=e90ad700&scoped=true"
import script from "./company-suspended.vue?vue&type=script&lang=js"
export * from "./company-suspended.vue?vue&type=script&lang=js"
import style0 from "./company-suspended.vue?vue&type=style&index=0&id=e90ad700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90ad700",
  null
  
)

export default component.exports